import React from "react";
import { Link } from "react-router-dom";
import whatsappIcon from "./img/parts/whatsapp-icon.svg";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

// WhatsApp floating button
const WhatsAppButton = React.memo(({ bottom, isMobile }) => (
  <Link
    to="https://wa.me/9418696322"
    target="_blank"
    className="whatapp_button_link_to"
    style={{
      bottom: bottom,
    }}
  >
    <img loading="lazy" src={whatsappIcon} alt="WhatsApp Button" />
  </Link>
));

// Scroll to top button
const MoveTopButton = React.memo(
  ({ bottom, onClick, isMobile, isScrolled }) => (
    <div
      className={`move-top-btn${isMobile ? "-mobile" : ""} ${
        isMobile && isScrolled ? "scrolled" : ""
      }`}
      onClick={onClick}
      style={{
        bottom: bottom,
      }}
    >
      <KeyboardArrowUpIcon id={`move-top-arrow${isMobile ? "-mobile" : ""}`} />
      <span className={`move-top-text${isMobile ? "-mobile" : ""}`}>TOP</span>
    </div>
  )
);

export { WhatsAppButton, MoveTopButton };
